module.exports = __webpack_public_path__ + "static/img/vrRoad_cover_1.89037560.png";